import React from 'react';

function About() {
  return (
    <div className="about-page">
      <h1>About Indosam Cricket Club</h1>
      <p>Founded in 2010, Indosam CC is dedicated to promoting cricket...</p>
    </div>
  );
}

export default About;